import React from "react";
import { Admin, Resource } from "react-admin";
import { AuthClient, DataProvider } from "./providers";
import MyLayout from "./layout/Layout";
import LoginPage from "./layout/Login";
import { Dashboard } from "./components/dashboard";
import spanishMessages from "ra-language-spanish";
import {
  Administrador,
  Cartonero,
  Coordinador,
  Pesaje,
  DashboardRedirect
} from "./services";

import CloudDownload from "@material-ui/icons/CloudDownload";
import PersonIcon from "@material-ui/icons/Person";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import ViewCarouselIcon from "@material-ui/icons/ViewCarousel";
import RoomIcon from "@material-ui/icons/Room";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import ArchiveIcon from "@material-ui/icons/Archive";
import StyleIcon from "@material-ui/icons/Style";
import AssignmentIcon from "@material-ui/icons/Assignment";
import StoreMallDirectoryIcon from "@material-ui/icons/StoreMallDirectory";
import Receipt from "@material-ui/icons/Receipt";
import PersonPinCircleIcon from "@material-ui/icons/PersonPinCircle";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import PrediosIcon from "@material-ui/icons/Star";

import CustomLanguageSpanish from "./custom-language-spanish";

const allLanguageSpanish = { ...CustomLanguageSpanish, ...spanishMessages };
const messages = { es: allLanguageSpanish };

const i18nProvider = locale => messages[locale];
const adminTitle = "Amanecer Coop Admin";

const App = () => (
  <Admin
    title={adminTitle}
    locale="es"
    i18nProvider={i18nProvider}
    appLayout={MyLayout}
    loginPage={LoginPage}
    dashboard={Dashboard}
    dataProvider={DataProvider}
    authProvider={AuthClient}
  >
    {permissions => {
      return [
        permissions === "admin" ? (
          <Resource
            name="administradores"
            list={Administrador.EditableAdministradorList}
            create={Administrador.AdministradorCreate}
            edit={Administrador.AdministradorEdit}
            icon={PersonOutlineIcon}
          />
        ) : null,
        permissions === "admin" ? <Resource name="operarios" /> : null,
        permissions === "admin" ? (
          <Resource
            name="recuperadores"
            list={Administrador.EditableCartoneroList}
            create={Administrador.CartoneroCreate}
            edit={Administrador.CartoneroEdit}
            icon={PersonIcon}
          />
        ) : null,
        permissions === "admin" ? (
          <Resource
            name="coordinadores"
            list={Administrador.EditableCoordinadorList}
            create={Administrador.CoordinadorCreate}
            edit={Administrador.CoordinadorEdit}
            icon={SupervisorAccountIcon}
          />
        ) : null,
        permissions === "admin" ? (
          <Resource
            name="pesadores"
            list={Administrador.EditablePesadorList}
            create={Administrador.PesadorCreate}
            edit={Administrador.PesadorEdit}
            icon={ShoppingBasketIcon}
          />
        ) : null,
        permissions === "admin" ? (
          <Resource
            name="enfardadores"
            list={Administrador.EditableEnfardadorList}
            create={Administrador.EnfardadorCreate}
            edit={Administrador.EnfardadorEdit}
            icon={ViewCarouselIcon}
          />
        ) : null,
        permissions === "admin" ? (
          <Resource
            name="auditores"
            list={Administrador.EditableAuditorList}
            create={Administrador.AuditorCreate}
            edit={Administrador.AuditorEdit}
            icon={VerifiedUserIcon}
          />
        ) : null,
        permissions === "admin" ? (
          <Resource
            name="etapas"
            list={Administrador.EditableEtapaList}
            create={Administrador.EtapaCreate}
            edit={Administrador.EtapaEdit}
            icon={PersonPinCircleIcon}
          />
        ) : null,
        permissions === "admin" ? (
          <Resource
            name="predios"
            list={Administrador.PredioList}
            create={Administrador.PredioCreate}
            edit={Administrador.PredioEdit}
            icon={PrediosIcon}
          />
        ) : null,
        permissions === "admin" ? (
          <Resource
            options={{ label: "Etapas (GG)" }}
            name="etapas-grandes-generadores"
            list={Administrador.EtapasGrandesGeneradoresList}
            create={Administrador.EtapasGrandesGeneradoresCreate}
            edit={Administrador.EtapasGrandesGeneradoresEdit}
            icon={RoomIcon}
          />
        ) : null,
        permissions === "admin" ? (
          <Resource
            name="entidades"
            list={Administrador.EntidadList}
            edit={Administrador.EntidadEdit}
            create={Administrador.EntidadCreate}
            icon={StoreMallDirectoryIcon}
          />
        ) : null,
        permissions === "admin" ? (
          <Resource
            options={{ label: "Grandes generadores" }}
            name="grandes-generadores"
            list={Administrador.GrandesGeneradoresList}
            create={Administrador.GrandesGeneradoresCreate}
            edit={Administrador.GrandesGeneradoresEdit}
            icon={LocationCityIcon}
          />
        ) : null,
        permissions === "admin" ? (
          <Resource
            name="materiales"
            list={Administrador.MaterialEditableList}
            create={Administrador.MaterialCreate}
            edit={Administrador.MaterialEdit}
            show={Administrador.MaterialShow}
            icon={StyleIcon}
          />
        ) : null,
        permissions === "admin" ? (
          <Resource
            options={{ label: "Ingreso de materiales" }}
            name="pesajes"
            list={Pesaje.PesajeListEdit}
            edit={Pesaje.PesajeEdit}
            create={Pesaje.PesajeCreate}
            icon={ArchiveIcon}
          />
        ) : null,
        permissions === "admin" ? (
          <Resource
            options={{ label: "Ingreso de terceros" }}
            name="ingreso-terceros"
            list={Administrador.IngresoTercerosList}
            edit={Administrador.IngresoTercerosEdit}
            create={Administrador.IngresoTercerosCreate}
            icon={ArchiveIcon}
          />
        ) : null,
        permissions === "admin" ? (
          <Resource
            options={{ label: "Ingreso de GG" }}
            name="ingreso-grandes-generadores"
            list={Administrador.IngresoGrandesGeneradoresList}
            edit={Administrador.IngresoGrandesGeneradoresEdit}
            create={Administrador.IngresoGrandesGeneradoresCreate}
            icon={ArchiveIcon}
          />
        ) : null,
        permissions === "admin" ? (
          <Resource
            options={{ label: "Producción" }}
            name="pesaje-material"
            list={Administrador.PesajeMaterialEditableList}
            create={Administrador.PesajeMaterialCreate}
            edit={Administrador.PesajeMaterialEdit}
            icon={AssignmentIcon}
          />
        ) : null,
        permissions === "admin" ? (
          <Resource
            options={{ label: "Salida" }}
            name="remitos"
            list={Administrador.RemitosList}
            create={Administrador.RemitosCreate}
            edit={Administrador.RemitosEdit}
            icon={Receipt}
          />
        ) : null,
        permissions === "admin" ? (
          <Resource name="operaciones" create={Administrador.OperacionCreate} />
        ) : null,
        permissions === "admin" ? (
          <Resource
            options={{ label: "Exportar Pesajes" }}
            name="exportar-pesaje"
            list={Administrador.ExportarPesajeCsv}
            icon={CloudDownload}
          />
        ) : null,
        permissions === "auditor" ? (
          <Resource
            name="pesajes"
            list={Pesaje.PesajeList}
            icon={ArchiveIcon}
          />
        ) : null,
        permissions === "auditor" ? (
          <Resource
            name="Exportar Pesaje"
            list={Administrador.ExportarPesajeCsv}
            icon={CloudDownload}
          />
        ) : null,
        permissions === "auditor" ? <Resource name="etapas" /> : null,
        permissions === "auditor" ? <Resource name="predios" /> : null,
        permissions === "coordinador" ? (
          <Resource
            name="coordinadores"
            edit={Coordinador.UserProfileEdit}
            list={DashboardRedirect}
          />
        ) : null,
        permissions === "coordinador" ? (
          <Resource
            name="recuperadores"
            list={Coordinador.CartoneroList}
            show={Coordinador.CartoneroShow}
            icon={PersonIcon}
          />
        ) : null,
        permissions === "coordinador" ? (
          <Resource
            name="pesajes"
            list={Pesaje.PesajeList}
            icon={ArchiveIcon}
          />
        ) : null,
        permissions === "coordinador" ? <Resource name="etapas" /> : null,
        permissions === "coordinador" ? <Resource name="predios" /> : null,
        permissions === "cartonero" ? (
          <Resource
            name="recuperadores"
            edit={Cartonero.UserProfileEdit}
            list={DashboardRedirect}
          />
        ) : null,
        permissions === "pesador" ? (
          <Resource
            name="pesajes"
            list={Pesaje.PesajeListEdit}
            edit={Pesaje.PesajeComentarioEdit}
            create={Pesaje.PesajeCreate}
            icon={ArchiveIcon}
          />
        ) : null,

        permissions === "pesador" ? <Resource name="entidades" /> : null,
        permissions === "pesador" ? <Resource name="operarios" /> : null,
        permissions === "pesador" ? <Resource name="materiales" /> : null,
        permissions === "pesador" ? (
          <Resource name="etapas-grandes-generadores" />
        ) : null,
        permissions === "pesador" ? <Resource name="etapas" /> : null,
        permissions === "pesador" ? (
          <Resource name="grandes-generadores" />
        ) : null,
        permissions === "pesador" ? <Resource name="predios" /> : null,
        permissions === "pesador" ? (
          <Resource
            options={{ label: "Ingreso de terceros" }}
            name="ingreso-terceros"
            list={Administrador.IngresoTercerosList}
            edit={Administrador.IngresoTercerosEdit}
            create={Administrador.IngresoTercerosCreate}
            icon={ArchiveIcon}
          />
        ) : null,
        permissions === "pesador" ? (
          <Resource
            options={{ label: "Ingreso de GG" }}
            name="ingreso-grandes-generadores"
            list={Administrador.IngresoGrandesGeneradoresList}
            edit={Administrador.IngresoGrandesGeneradoresEdit}
            create={Administrador.IngresoGrandesGeneradoresCreate}
            icon={ArchiveIcon}
          />
        ) : null,
        permissions === "pesador" ? (
          <Resource
            options={{ label: "Producción" }}
            name="pesaje-material"
            list={Administrador.PesajeMaterialEditableList}
            create={Administrador.PesajeMaterialCreate}
            edit={Administrador.PesajeMaterialEdit}
            icon={AssignmentIcon}
          />
        ) : null,
        permissions === "pesador" ? (
          <Resource
            options={{ label: "Remitos" }}
            name="remitos"
            list={Administrador.RemitosList}
            create={Administrador.RemitosCreate}
            edit={Administrador.RemitosEdit}
            icon={Receipt}
          />
        ) : null,

        permissions === "enfardador" ? (
          <Resource
            options={{ label: "Pesaje de materiales" }}
            name="pesaje-material"
            list={Administrador.PesajeMaterialList}
            create={Administrador.CargarPesajeMateriales}
            icon={StyleIcon}
          />
        ) : null,

        <div />
      ];
    }}
  </Admin>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js